import { MUIDataTableOptions } from "mui-datatables";
import { defaultOptions } from "../../../../dashboard/reports/components/table/utils/options";
import colors from "common/styles/colors";

export const companyDialogTableOptions: MUIDataTableOptions = {
  ...defaultOptions,
  selectableRows: "none",
  search: false,
  filter: false,
  download: false,
  print: false,
  viewColumns: false,
  pagination: false,
  sort: false,
  responsive: "standard",
  elevation: 0
};

export const headerCellProps = () => ({
  style: {
    backgroundColor: colors.lightGrey1,
    fontWeight: 600,
    fontSize: 14,
    color: colors.darkGrey1,
    textTransform: "capitalize"
  }
});
